function collectErrorFragments (err) {
    const fragments = [];
    if (!err) return fragments;

    const rawCandidates = [
        err.data,
        err.body,
        err.message,
        err.statusText,
        err.responseText
    ];

    rawCandidates.forEach((candidate) => {
        if (!candidate) return;
        if (typeof candidate === 'string') {
            fragments.push(candidate);
            return;
        }
        if (typeof candidate === 'object') {
            try {
                fragments.push(JSON.stringify(candidate));
            } catch (ex) {
                // ignore serialization errors
            }
        }
    });

    return fragments;
}

export function isBlacklistedTokenError (err) {
    const status = err && err.status;
    if (status && status !== 401 && status !== 403) {
        return false;
    }

    const body = collectErrorFragments(err).join(' ').toLowerCase();
    if (!body) return false;

    return body.includes('token was blacklisted') ||
        (body.includes('token') && body.includes('blacklisted'));
}



// WEBPACK FOOTER //
// ./src/services/api/authError.js